(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atl-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-atl-slider]').forEach(function (track) {
        if (track.dataset.atlReady) return;
        track.dataset.atlReady = '1';
        var dots = track.parentElement.querySelectorAll('[data-atl-dot]');
        var cards = track.children;
        function active() {
          var best = 0, bestD = Infinity, left = track.getBoundingClientRect().left;
          for (var i = 0; i < cards.length; i++) {
            var d = Math.abs(cards[i].getBoundingClientRect().left - left - parseFloat(getComputedStyle(track).paddingLeft));
            if (d < bestD) { bestD = d; best = i; }
          }
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); d.setAttribute('aria-current', i === best ? 'true' : 'false'); });
        }
        var t;
        track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(active); }, { passive: true });
        dots.forEach(function (d) {
          d.addEventListener('click', function () {
            var c = cards[+d.dataset.atlDot];
            if (c) track.scrollTo({ left: c.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: 'smooth' });
          });
        });
        track.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth * 0.86, behavior: 'smooth' });
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
